"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                ProgressBarValue: "Current value {0} out of {1}"
            }
        });
        var ProgressBar = /** @class */ (function (_super) {
            __extends(ProgressBar, _super);
            function ProgressBar(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.Percent = $dyn.computed(function () {
                    var value = $dyn.value(_this.Value);
                    var minimumValue = $dyn.value(_this.MinimumValue);
                    var maximumValue = $dyn.value(_this.MaximumValue);
                    if (minimumValue < maximumValue) {
                        _this._percentageComplete = Math.round((value - minimumValue) / (maximumValue - minimumValue) * 100);
                        if (_this._percentageComplete > 100) {
                            _this._percentageComplete = 100;
                        }
                        else if (_this._percentageComplete < 0) {
                            _this._percentageComplete = 0;
                        }
                    }
                    else {
                        _this._percentageComplete = 0;
                    }
                    return _this._percentageComplete;
                });
                $dyn.observe(_this.Value, function (value) {
                    var minimumValue = $dyn.value(_this.MinimumValue);
                    var maximumValue = $dyn.value(_this.MaximumValue);
                    if (maximumValue - minimumValue < 0) {
                        $dyn.error({ Message: $dyn.label("Maximum value less than Minimum value"), Label: "Maximum value less than Minimum value" }, _this);
                    }
                    if (value - minimumValue < 0) {
                        $dyn.error({ Message: $dyn.label("Value is less than Minimum value"), Label: "Value is less than Minimum value" }, _this);
                    }
                    if (value - maximumValue > 0) {
                        $dyn.error({ Message: $dyn.label("Value is greater than Maximum value"), Label: "Value is greater than Maximum value" }, _this);
                    }
                    _this.element.setAttribute("aria-busy", "true");
                    _this.element.setAttribute("aria-label", $dyn.format($dyn.label("ProgressBarValue"), value, maximumValue));
                    _this.element.setAttribute("aria-busy", "false");
                    if (value) {
                        _this.element.setAttribute("aria-live", "assertive");
                    }
                    else {
                        _this.element.removeAttribute("aria-live");
                    }
                });
                return _this;
            }
            return ProgressBar;
        }($dyn.ui.Control));
        controls.ProgressBar = ProgressBar;
        ProgressBar.prototype.IsIndeterminate = false;
        ProgressBar.prototype.MaximumValue = 100;
        ProgressBar.prototype.MinimumValue = 0;
        ProgressBar.prototype.StepValue = 1;
        ProgressBar.prototype.Value = 0;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ProgressBar.js.map
